import type { PoiData } from '$lib/components/pois/types';
import { PREFETCH_IMAGES_COUNT } from '$lib/constants/poilist';

export function getImagePreloadData(poisList: PoiData[]) {
	const imageUrls: string[] = poisList
		.slice(0, 20)
		.map((item) => {
			return ('images' in item && item?.images?.find(img => !!img.w320)?.w320) || '';
		})
		.filter(url => url.length > 0);

	// Deduplicate image URLs to prevent duplicate keys
	const uniqueImageUrls = [...new Set(imageUrls)];

	const preconnectOrigins: string[] = [
		...new Set(imageUrls.map(u => new URL(u).origin)), // deduplicate by sieving url origins through a Set
		'https://map7.viamichelin.com',
		'https://map8.viamichelin.com',
		'https://map9.viamichelin.com',
		'https://sdk.privacy-center.org',
		// TODO map7 - map9 identified with empirical tests, needs a complete list or should we not preconnect?
	];

	const preloadImages = uniqueImageUrls.slice(0, PREFETCH_IMAGES_COUNT);

	return {
		preconnectOrigins,
		preloadImages,
	};
}
